fragment NotificationFragment on Notification {
    id
    key
    subject
    body
    type
    recipients
    has_recipients

    updated_at
    created_at
}